import { OMD_API_ENDPOINTS } from '../config/apiConfig';
import HttpClient from '../helpers/HttpClient';


class BeforeAfterService {
    // POST request to fetch before after page data
    async getBeforeAfterPageData(payload) {
        const response = await HttpClient.get(OMD_API_ENDPOINTS.BEFORE_AFTER_PAGE);
        return response;
    }
}

const beforeAfterService = new BeforeAfterService();
export default beforeAfterService;
